import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ROUTES } from 'global/constants';
import { EducatorContentDashboard, FavoritesDashboard } from 'library/components';
import { EducatorClassroomsDashboard, LearnerClassroomsDashboard } from 'classrooms/components';
import { TabLink, TabbedPageLayout } from '../TabbedPageLayout';
import messages from './displayMessages';

export const DashboardNavigationLinks: TabLink[] = [
    {
        to: ROUTES.Dashboard.HOME,
        message: messages.tabMyContent,
        exact: true,
        onlyEducator: false
    },
    {
        to: ROUTES.Dashboard.FAVORITES,
        message: messages.tabFavorites,
        exact: true,
        onlyEducator: false
    },
    {
        to: ROUTES.Dashboard.EDUCATOR_CLASSROOMS,
        message: messages.tabMyClasses,
        exact: true,
        onlyEducator: true
    },
    {
        to: ROUTES.Dashboard.LEARNER_CLASSROOMS,
        message: messages.tabClasses,
        exact: true,
        onlyEducator: false
    },
    {
        to: ROUTES.Messages.HOME,
        message: messages.tabMessages,
        exact: true,
        onlyEducator: false
    },
];

/**
 * Dashboard page container.
 * - Render available tabs for educator and leaner
 */
export class DashboardPage extends React.PureComponent<RouteComponentProps> {

    public render() {
        return (
            <TabbedPageLayout
                pageTitle={this.title}
                tabs={DashboardNavigationLinks}
            >
                {this.content()}
            </TabbedPageLayout>
        );
    }

    private get title() {
        switch (this.props.match.path) {
            case ROUTES.Dashboard.HOME:
                return messages.myContentPageTitle;
            case ROUTES.Dashboard.FAVORITES:
                return messages.favoritesPageTitle;
            case ROUTES.Dashboard.EDUCATOR_CLASSROOMS:
                return messages.classroomsPageTitle;
            case ROUTES.Dashboard.LEARNER_CLASSROOMS:
                return messages.myClassroomsPageTitle;
            default:
                return undefined;
        }
    }

    private content() {
        switch (this.props.match.path) {
            case ROUTES.Dashboard.HOME:
                return <EducatorContentDashboard />;
            case ROUTES.Dashboard.FAVORITES:
                return <FavoritesDashboard />;
            case ROUTES.Dashboard.EDUCATOR_CLASSROOMS:
                return <EducatorClassroomsDashboard />;
            case ROUTES.Dashboard.LEARNER_CLASSROOMS:
                return <LearnerClassroomsDashboard />;
            default:
                return null;
        }
    }

}
